import React from "react";
import PropTypes from "prop-types";
import { propOr } from "ramda";
import { styled } from "@mui/material/styles";

import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";

import { isAppleiPadDevice } from "~/utils";

const links = {
  imprint: "https://login.mildenberger-digital.de/meta-iframe-buch/impressum",
  usage_rights: "https://login.mildenberger-digital.de/meta-iframe-buch/nutzungsbedingungen",
  privacy: "https://login.mildenberger-digital.de/meta-iframe-buch/datenschutz",
  contact: "https://login.mildenberger-digital.de/meta-iframe-buch/kontakt"
};

const Content = styled(DialogContent)(props => ({
  height: "100%",
  flex: "none",
  position: "relative",
  overflowX: "hidden",
  overflowY: isAppleiPadDevice() ? "scroll" : "hidden",
  "-webkit-overflow-scrolling": "touch"
}));

const Button = styled(IconButton)(props => ({
  position: "absolute",
  top: props.theme.spacing(2),
  right: props.theme.spacing(2),
  "&:focus-visible": {
    outline: props.theme.outline(),
    outlineOffset: "-2px"
  }
}));

const Frame = styled("iframe")(props => ({
  minWidth: "100%",
  minHeight: "100%",
  maxWidth: "100%",
  maxHeight: "100%",
  outline: 0,
  border: 0,
  "-webkit-overflow-scrolling": "touch"
}));

function FrameModal({ link, classes, hideModal, kind }) {
  const href = propOr(null, link, links);

  if (!href) {
    return null;
  }

  return (
    <Content aria-label={href} id={`${kind}-modal-title`}>
      <Button onClick={hideModal} size="large" aria-label="Schließen">
        <CloseIcon />
      </Button>
      <Frame
        title="Mildenberger Digital"
        src={href}
        width="100%"
        height="100%"
        scrolling={isAppleiPadDevice() ? "no" : "yes"}
      />
    </Content>
  );
}

FrameModal.propTypes = {
  link: PropTypes.string,
  classes: PropTypes.object,
  hideModal: PropTypes.func,
  kind: PropTypes.string
};

export default FrameModal;
